import { Badge } from '@efira/ui';

import { usePlan } from '../api/queries';
import { PLAN_NAME, PRO_STATUS } from './planWords';

/**
 * СОСТОЯНИЕ ТАРИФА - ИЗ ОДНОГО ИСТОЧНИКА. Единица 21, находка N-11.
 *
 * «Две правды о Pro»: меню аккаунта говорило «в разработке», окно тарифа
 * - цену и активную зелёную «Оформить Pro», отказ приходил после нажатия.
 * Тариф назывался «Free» в меню и «Бесплатный» в окне. Каждое место писало
 * своё слово, потому что слова жили в местах.
 *
 * Теперь слова живут здесь, а состояние приходит с сервера одним запросом
 * (`/api/plan`: действующий тариф и `checkout.connected`). Все места
 * берут отсюда - меню аккаунта, окно тарифа, раздел «Оплата», причина в
 * левой колонке, лента новостей, - и ставят пометку `data-pro-status` /
 * `data-plan-name`. Слова - в `planWords.ts` (без React: их читают и
 * сценарии). Ворота: `pnpm ui:check` (`UI-13` - слов тарифа нет нигде,
 * кроме `planWords.ts`) и `e2e/class-plan.spec.ts` (обход мест и
 * сверка слова).
 */
export { PLAN_NAME, PRO_STATUS } from './planWords';

export interface PlanState {
  /** Данные ещё не пришли. */
  loading: boolean;
  current: keyof typeof PLAN_NAME;
  name: (typeof PLAN_NAME)[keyof typeof PLAN_NAME];
  /** Платёжный провайдер принимает деньги. */
  selling: boolean;
  status: (typeof PRO_STATUS)[keyof typeof PRO_STATUS];
}

export function usePlanState(): PlanState {
  const plan = usePlan();
  const current = plan.data?.current.id === 'pro' ? 'pro' : 'free';
  const selling = plan.data?.checkout.connected === true;

  return {
    loading: plan.data === undefined,
    current,
    name: PLAN_NAME[current],
    selling,
    status: selling ? PRO_STATUS.selling : PRO_STATUS.waiting,
  };
}

/** Название действующего тарифа - плашкой. */
export function PlanName() {
  const state = usePlanState();

  return (
    <Badge variant={state.current === 'pro' ? 'default' : 'secondary'} data-plan-name={state.name}>
      {state.name}
    </Badge>
  );
}

/** Можно ли оформить Pro - одним словом, плашкой. */
export function ProStatus() {
  const state = usePlanState();

  if (state.loading) return null;

  return (
    <Badge variant="secondary" data-pro-status={state.status}>
      {state.status}
    </Badge>
  );
}
